webpackJsonp([1,35],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = new _vue2.default();

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(6),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'btn',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default'
	    },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    block: {
	      type: Boolean,
	      default: false
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    disable: {
	      type: Boolean,
	      default: true
	    },
	    loading: {
	      type: Boolean,
	      default: false
	    },
	    submit: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      if (this.submit !== '') {
	        _eventbus2.default.$emit('btn-submit', this.submit);
	      }
	      if (this.disable && !this.loading) {
	        this.$emit('on-click', '');
	      }
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn",
	    class: [
	      'btn-' + _vm.theme,
	      'btn-' + _vm.size,
	      _vm.block ? 'btn-block' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.icon != '' && !_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont",
	    class: [_vm.icon ? 'icon-' + _vm.icon : '']
	  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont icon-loading loading"
	  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])])
	},staticRenderFns: []}

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	'use strict';
	
	var Format = {
	  type: {
	    required: {
	      reg: /.{1,}/,
	      msg: '此项不能为空'
	    },
	    email: {
	      reg: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
	      msg: '邮箱格式错误'
	    },
	    phone: {
	      reg: /^\d{11}$/,
	      msg: '手机格式错误'
	    },
	    float: {
	      reg: /^\d+(.\d+)?$/,
	      msg: '必须为整数或小数'
	    },
	    int: {
	      reg: /^\d+$/,
	      msg: '必须为整数'
	    }
	  },
	  do: function _do(required, format, value) {
	    var _this = this;
	    var pass = { state: true, msg: '' };
	    try {
	      if (typeof value === 'string') {
	        var value = value.replace(/\s/, '');
	      }
	    } catch (e) {
	      return {
	        state: false,
	        msg: '验证发生错误'
	      };
	    }
	
	    if (required) {
	      if (!_this.type.required.reg.test(value)) {
	        return {
	          state: false,
	          msg: _this.type.required.msg
	        };
	      }
	    }
	
	    if (typeof format === 'string') {
	      var tester = _this.type[format];
	    } else {
	      var tester = format;
	    }
	
	    if (tester == undefined) {
	      return pass;
	    }
	
	    if (tester.reg.test(value)) {
	      return pass;
	    } else {
	      if (value == '') {
	        return pass;
	      }
	      return {
	        state: false,
	        msg: tester.msg
	      };
	    }
	  }
	};
	
	module.exports = Format;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _format = __webpack_require__(8);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'formInput',
	  props: {
	    type: {
	      type: String,
	      default: 'text'
	    },
	    name: {
	      type: String,
	      default: ''
	    },
	    value: {
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default' },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    state: {
	      type: String,
	      default: 'normal' },
	    enable: {
	      type: Boolean,
	      default: true
	    },
	    holder: {
	      type: String,
	      default: ''
	    },
	    required: {
	      type: Boolean,
	      default: false
	    },
	    format: {
	      type: String,
	      default: ''
	    },
	    label: {
	      type: String,
	      default: ''
	    },
	    for: {
	      type: String,
	      default: ''
	    },
	    focus: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    getValue: function getValue() {
	      return this.valueSelf;
	    },
	    setState: function setState(state) {
	      this.stateSelf = state;
	    },
	    verify: function verify() {
	      var check = _format2.default.do(this.required, this.format, this.valueSelf);
	      if (check.state) {
	        this.setState('');
	      } else {
	        this.setState('wrong');
	      }
	      return check;
	    },
	    formVerify: function formVerify(formid) {
	      if (this.for === formid) {
	        _eventbus2.default.$emit('input-verify', {
	          formid: formid,
	          result: this.verify(),
	          data: {
	            name: this.name,
	            value: this.valueSelf
	          }
	        });
	      }
	    },
	    handleClick: function handleClick() {
	      this.$emit('on-click', '');
	    }
	  },
	  created: function created() {
	    _eventbus2.default.$on('form-verify', this.formVerify);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _eventbus2.default.$off('form-verify', this.formVerify);
	  },
	  mounted: function mounted() {
	    if (this.focus) {
	      this.$refs.input.focus();
	    }
	  },
	
	  watch: {
	    value: function value(newval) {
	      this.valueSelf = newval;
	    },
	    valueSelf: function valueSelf(newval) {
	      this.$emit('input', newval);
	    }
	  },
	  data: function data() {
	    return {
	      valueSelf: this.value,
	      stateSelf: this.state
	    };
	  }
	};

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(9),
	  /* template */
	  __webpack_require__(11),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.label != '') ? _c('div', {
	    staticClass: "form-item",
	    class: [
	      'form-item-' + this.theme
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_c('label', {
	    class: ['label-' + this.size],
	    attrs: {
	      "for": _vm.name
	    }
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ]
	  }, [(_vm.type == 'text') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      'input-' + this.theme
	    ],
	    attrs: {
	      "type": "text",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      'input-' + this.theme
	    ],
	    attrs: {
	      "type": "password",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])]) : _c('div', {
	    staticClass: "form-item",
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.type == 'text') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      this.theme == 'underline' ? 'input-' + this.theme : ''
	    ],
	    attrs: {
	      "type": "text",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      this.theme == 'underline' ? 'input-' + this.theme : ''
	    ],
	    attrs: {
	      "type": "password",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(24),
	  /* template */
	  __webpack_require__(34),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 21:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'drawer',
	  props: {
	    show: {
	      type: Boolean,
	      default: false
	    },
	    position: {
	      type: String,
	      default: 'center' }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      this.$emit('on-layoutclick', this.show);
	      this.$emit('on-click', this.show);
	    }
	  },
	  data: function data() {
	    return {
	      animate: {
	        center: 'modal',
	        bottom: 'bt',
	        left: 'lr',
	        top: 'tb',
	        'top-header': 'tb'
	      }
	    };
	  }
	};

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'formGroup',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default'
	    },
	    size: {
	      type: String,
	      default: 'default'
	    }
	  },
	  methods: {
	    btnSubmit: function btnSubmit(formid) {
	      if (formid === this.name) {
	        this.pass = true;
	        _eventbus2.default.$emit('form-verify', formid);
	
	        if (this.pass) {
	          this.$emit('on-submit', this.data);
	        }
	      }
	    },
	    receiveInputData: function receiveInputData(data) {
	      if (data.data.name === '' || data.data.name === undefined) {
	        this.pass = false;
	        return;
	      }
	
	      if (data.formid === this.name) {
	        if (data.result.state) {
	          this.data[data.data.name] = data.data.value;
	        } else {
	          this.pass = false;
	          delete this.data[data.data.name];
	        }
	      }
	    }
	  },
	  created: function created() {
	    _eventbus2.default.$on('btn-submit', this.btnSubmit);
	    _eventbus2.default.$on('input-verify', this.receiveInputData);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _eventbus2.default.$off('btn-submit', this.btnSubmit);
	    _eventbus2.default.$off('input-verify', this.receiveInputData);
	  },
	  data: function data() {
	    return {
	      data: {},
	      pass: true
	    };
	  }
	};

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: {
	      default: 0
	    },
	    text: {
	      default: ''
	    },
	
	    addon: {
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      selected: false
	    };
	  },
	
	  computed: {},
	  ready: function ready() {},
	  attached: function attached() {},
	
	  methods: {
	    handleClick: function handleClick() {
	      this.$parent.handleClick({
	        value: this.value,
	        text: this.text,
	        addon: this.addon
	      });
	    }
	  },
	  components: {}
	};

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectorItem = __webpack_require__(17);
	
	var _selectorItem2 = _interopRequireDefault(_selectorItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  item: _selectorItem2.default,
	  props: {
	    title: {
	      type: String,
	      default: ''
	    },
	    value: {
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default' },
	    underline: {
	      default: false
	    },
	    size: {
	      type: String,
	      default: 'normal'
	    },
	    options: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    maxHeight: {
	      default: ''
	    },
	    unselected: {
	      default: false
	    }
	  },
	  computed: {
	    listHeight: function listHeight() {
	      if (this.maxHeight !== '') {
	        return { height: this.maxHeight };
	      }
	      return {};
	    }
	  },
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {
	    this.updateSlot();
	  },
	
	  watch: {
	    value: function value() {
	      this.updateSlot();
	    }
	  },
	  methods: {
	    handleClick: function handleClick(value) {
	      if (this.unselected && value.value === this.value) {
	        this.$emit('on-change', {});
	        this.$emit('input', null);
	      } else {
	        this.$emit('on-change', value);
	        this.$emit('input', value.value);
	      }
	    },
	    getValue: function getValue() {
	      return this.value;
	    },
	    setValue: function setValue(val) {
	      console.log('警告：selector:setValue()是一个向前兼容的方法，不推荐使用');
	      this.$emit('input', val);
	    },
	    updateSlot: function updateSlot() {
	      var _this = this;
	
	      if (this.$children && this.$children.length > 0) {
	        this.$children.forEach(function (item) {
	          if (item.value === _this.value) {
	            item.selected = true;
	          } else {
	            item.selected = false;
	          }
	        });
	      }
	    }
	  },
	  components: {}
	};

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(21),
	  /* template */
	  __webpack_require__(33),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(22),
	  /* template */
	  __webpack_require__(38),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(25),
	  /* template */
	  __webpack_require__(36),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('transition', {
	    attrs: {
	      "name": "layout"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "layout-opacity",
	    class: [_vm.position == 'top-header' ? 'layout-header' : ''],
	    on: {
	      "click": _vm.handleClick
	    }
	  })]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": _vm.animate[_vm.position]
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "drawer",
	    class: ['drawer-' + _vm.position]
	  }, [_c('div', {
	    staticClass: "drawer-box"
	  }, [_vm._t("default")], 2)])])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    class: [_vm.selected ? 'selected' : ''],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n  "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "selector",
	    class: ['selector-' + _vm.size, 'selector-' + _vm.theme, _vm.underline != '' ? 'selector-underline' : '']
	  }, [_c('h3', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.title != ''),
	      expression: "title!=''"
	    }],
	    staticClass: "selector-title"
	  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('ul', {
	    staticClass: "selector-list",
	    style: (_vm.listHeight)
	  }, [_vm._l((_vm.options), function(item) {
	    return _c('li', {
	      class: [item.value == _vm.value ? 'selected' : ''],
	      on: {
	        "click": function($event) {
	          _vm.handleClick(item)
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
	  }), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form",
	    class: [
	      'form-' + _vm.theme,
	      'form-' + _vm.size
	    ]
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _format = __webpack_require__(8);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'boselect',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    value: {
	      default: ''
	    },
	    options: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    theme: {
	      type: String,
	      default: 'default' },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    icon: {
	      type: String,
	      default: 'unfold'
	    },
	    state: {
	      type: String,
	      default: 'normal' },
	    enable: {
	      type: Boolean,
	      default: true
	    },
	    required: {
	      type: Boolean,
	      default: false
	    },
	    label: {
	      type: String,
	      default: ''
	    },
	    for: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    getValue: function getValue() {
	      return this.valueSelf;
	    },
	    setState: function setState(state) {
	      this.stateSelf = state;
	    },
	    verify: function verify() {
	      var check = _format2.default.do(this.required, '', this.valueSelf);
	      if (check.state) {
	        this.setState('');
	      } else {
	        this.setState('wrong');
	      }
	      return check;
	    },
	    formVerify: function formVerify(formid) {
	      if (this.for === formid) {
	        _eventbus2.default.$emit('input-verify', {
	          formid: formid,
	          result: this.verify(),
	          data: {
	            name: this.name,
	            value: this.valueSelf
	          }
	        });
	      }
	    }
	  },
	  created: function created() {
	    _eventbus2.default.$on('form-verify', this.formVerify);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _eventbus2.default.$off('form-verify', this.formVerify);
	  },
	
	  watch: {
	    value: function value(newval) {
	      this.valueSelf = newval;
	    }
	  },
	  data: function data() {
	    return {
	      valueSelf: this.value,
	      stateSelf: this.state
	    };
	  }
	};

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(45),
	  /* template */
	  __webpack_require__(55),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.label != '') ? _c('div', {
	    staticClass: "form-item",
	    class: [
	      'form-item-' + this.theme
	    ]
	  }, [_c('label', {
	    class: ['label-' + this.size],
	    attrs: {
	      "for": _vm.name
	    }
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ]
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    staticClass: "select form-control",
	    class: [
	      'select-' + this.size,
	      this.theme == 'underline' ? 'select-' + this.theme : ''
	    ],
	    attrs: {
	      "name": _vm.name
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.valueSelf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('option', {
	      domProps: {
	        "value": item.value
	      }
	    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")])
	  })), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])]) : _c('div', {
	    staticClass: "form-item",
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ]
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    staticClass: "select form-control",
	    class: [
	      'select-' + this.size,
	      this.theme == 'underline' ? 'select-' + this.theme : ''
	    ],
	    attrs: {
	      "name": _vm.name
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.valueSelf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('option', {
	      domProps: {
	        "value": item.value
	      }
	    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
	  })), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(118),
	  /* template */
	  __webpack_require__(223),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formGroup = __webpack_require__(29);
	
	var _formGroup2 = _interopRequireDefault(_formGroup);
	
	var _boInput = __webpack_require__(10);
	
	var _boInput2 = _interopRequireDefault(_boInput);
	
	var _boSelect = __webpack_require__(49);
	
	var _boSelect2 = _interopRequireDefault(_boSelect);
	
	var _btn = __webpack_require__(4);
	
	var _btn2 = _interopRequireDefault(_btn);
	
	var _drawer = __webpack_require__(28);
	
	var _drawer2 = _interopRequireDefault(_drawer);
	
	var _selector = __webpack_require__(31);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _selectorItem = __webpack_require__(17);
	
	var _selectorItem2 = _interopRequireDefault(_selectorItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'test1',
	  components: {
	    FormGroup: _formGroup2.default,
	    FormInput: _boInput2.default,
	    BoSelect: _boSelect2.default,
	    Btn: _btn2.default,
	    Drawer: _drawer2.default,
	    Selector: _selector2.default,
	    SelectorItem: _selectorItem2.default
	  },
	  methods: {
	    submit: function submit(data) {
	      console.log(data);
	    },
	    changeTheme: function changeTheme() {
	      if (this.theme === 'blank') {
	        this.theme = 'head';
	      } else {
	        this.theme = 'blank';
	      }
	    },
	    openDrawer: function openDrawer() {
	      this.showDrawer = true;
	    }
	  },
	  data: function data() {
	    return {
	      theme: 'blank',
	      showDrawer: false,
	      sval: ''
	    };
	  }
	};

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('form-group', {
	    attrs: {
	      "theme": _vm.theme,
	      "size": "lg",
	      "name": "testform"
	    },
	    on: {
	      "on-submit": _vm.submit
	    }
	  }, [_c('form-input', {
	    attrs: {
	      "label": "手机号",
	      "holder": "Phone",
	      "format": "phone",
	      "required": true,
	      "for": "testform",
	      "name": "phone"
	    }
	  }), _vm._v(" "), _c('form-input', {
	    attrs: {
	      "focus": "",
	      "label": "邮 箱",
	      "holder": "输入邮箱",
	      "format": "email",
	      "required": true,
	      "for": "testform",
	      "name": "email"
	    }
	  }), _vm._v(" "), _c('form-input', {
	    attrs: {
	      "label": "小 数",
	      "holder": "输入小数",
	      "format": "float",
	      "required": true,
	      "for": "testform",
	      "name": "float"
	    }
	  }), _vm._v(" "), _c('form-input', {
	    attrs: {
	      "label": "整 数",
	      "holder": "输入整数",
	      "format": "int",
	      "required": true,
	      "for": "testform",
	      "name": "int"
	    }
	  }), _vm._v(" "), _c('form-input', {
	    attrs: {
	      "label": "模拟下拉",
	      "holder": "",
	      "format": "int",
	      "required": true,
	      "name": "boselect",
	      "icon": "people",
	      "enable": false
	    },
	    on: {
	      "on-click": _vm.openDrawer
	    }
	  }), _vm._v(" "), _c('bo-select', {
	    attrs: {
	      "label": "原生下拉",
	      "for": "testform",
	      "name": "select",
	      "value": "1",
	      "required": true,
	      "options": [{
	        text: 'Item 1',
	        value: 1
	      }, {
	        text: 'Item 2',
	        value: 2
	      }]
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "p2222"
	  }, [_c('btn', {
	    attrs: {
	      "theme": "primary",
	      "block": true,
	      "size": "lg",
	      "submit": "testform",
	      "name": "确 认"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "p2222"
	  }, [_c('btn', {
	    attrs: {
	      "theme": "",
	      "block": true,
	      "size": "lg",
	      "name": "切换风格"
	    },
	    on: {
	      "on-click": _vm.changeTheme
	    }
	  })], 1), _vm._v(" "), _c('drawer', {
	    attrs: {
	      "show": _vm.showDrawer,
	      "position": "center"
	    }
	  }, [_c('selector', {
	    attrs: {
	      "size": "lg",
	      "underline": "true"
	    },
	    model: {
	      value: (_vm.sval),
	      callback: function($$v) {
	        _vm.sval = $$v
	      },
	      expression: "sval"
	    }
	  }, [_c('selector-item', {
	    attrs: {
	      "text": "Item 1",
	      "value": "1"
	    }
	  }), _vm._v(" "), _c('selector-item', {
	    attrs: {
	      "text": "Item 2",
	      "value": "2"
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.0238b2d5f2de808b2c36.js